import { styled } from '@mui/material/styles';
import { ToolbarStyled } from '@/components/toolbars/DefaultToolbar/styled';
import {
  DISABLED_CONTROL_COLOR,
  VENDOR_LINK_COLOR,
  VENDOR_LINK_COLOR_DARK,
} from '@/pages/Candidate/view/oneOffOrder/constants';
import { TURN_STYLES } from '@/styles/theme';

const filledInput = {
  '& .MuiFormControl-root': {
    margin: 0,
    width: '100%',
  },
  '& .MuiAutocomplete-root': {
    width: '100%',
  },
  '& .MuiOutlinedInput-root': {
    width: '100%',
    maxWidth: '100%',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    marginRight: 0,
    marginTop: '6px',
  },
  '& .MuiStack-root .RaFileInput-dropZone': {
    width: '100%',
  },
};

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',

  width: '100%',
  marginBottom: '20px',
  ...filledInput,
});

export const FileUrlContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  minWidth: 0,

  fontSize: '13px',

  '& a': {
    color: VENDOR_LINK_COLOR,
    fontWeight: 500,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '& button': {
    flex: '0 0 auto',
  },
});

export const ReportLabel = styled('span')({
  color: '#6b7280',
  flex: '0 0 auto',
  fontSize: '13px',
});

export const ReportNotice = styled('span')({
  color: '#92400e',
  backgroundColor: '#fffbeb',
  border: '1px solid #fcd34d',
  borderRadius: '6px',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 1.3,
  padding: '4px 8px',
  whiteSpace: 'nowrap',
});

export const OverrideRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const fieldset = {
  border: '1px solid #e5e7eb',
  borderRadius: '8px',
  margin: 0,
  padding: '16px',
  display: 'grid',
  gap: '16px',
  minWidth: 0,
  width: '100%',

  '& legend': {
    padding: '0 6px',
    fontSize: '13px',
    fontWeight: 600,
  },
};

export const CheckFields = styled('fieldset')(fieldset);

export const OrderFields = styled('fieldset')(fieldset);

export const Pair = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
  alignItems: 'start',
  [theme.breakpoints.down(720)]: {
    gridTemplateColumns: '1fr',
  },
}));

export const Span2 = styled('div')(({ theme }) => ({
  gridColumn: '1 / -1',
  [theme.breakpoints.down(720)]: {
    gridColumn: 'auto',
  },
}));

export const ProofBlock = styled('div')({
  display: 'grid',
  gap: '12px',

  '& .RaFileInput-dropZone': {
    width: '100% !important',
    minHeight: '148px',
    border: '1px dashed #D6C9F5 !important',
    borderRadius: '12px !important',
    backgroundColor: '#F7F5FF !important',
    padding: '8px !important',
  },
});

export const ProofIntro = styled('div')({
  display: 'grid',
  gap: '2px',
});

export const ProofTitle = styled('h3')(({ theme }) => ({
  margin: 0,
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : '#101828',
  fontSize: '16px',
  fontWeight: 600,
}));

export const ProofSubtitle = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.palette.mode === 'dark' ? DISABLED_CONTROL_COLOR : '#667085',
  fontSize: '13px',
}));

export const UploadCount = styled('p')({
  margin: '12px 0 0',
  color: '#344054',
  fontSize: '13px',
  fontWeight: 600,
});

export const DropHint = styled('div')({
  display: 'grid',
  justifyItems: 'center',
  gap: '4px',
  padding: '16px 12px',
});

export const DropIcon = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  marginBottom: 4,
  borderRadius: '50%',
  background: '#EDE9FE',
  color: '#7364DB',

  '& svg': { fontSize: 22 },
});

export const DropLead = styled('p')({
  margin: 0,
  color: '#344054',
  fontSize: '14px',
});

export const DropAction = styled('span')(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? VENDOR_LINK_COLOR_DARK : VENDOR_LINK_COLOR,
  fontWeight: 600,
}));

export const DropNote = styled('p')({
  margin: 0,
  color: '#98A2B3',
  fontSize: '12px',
});

export const FileList = styled('div')({
  display: 'grid',
  gap: '10px',
});

export const FileCard = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  border: '1px solid #EAECF0',
  borderRadius: '12px',
  padding: '12px 14px',
  background: '#fff',
});

export const FileIcon = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  flex: '0 0 auto',
  borderRadius: '8px',
  background: '#F4F0FF',
  color: '#7364DB',

  '& svg': { fontSize: 20 },
});

export const FileBody = styled('div')({
  flex: '1 1 auto',
  minWidth: 0,
  display: 'grid',
  gap: '2px',
});

export const FileTitle = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  minWidth: 0,
  color: '#101828',
  fontSize: '14px',
  fontWeight: 600,

  '& a': {
    color: '#7364DB',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '& .MuiSvgIcon-root': {
    color: '#12B76A',
    fontSize: 16,
  },
});

export const FileNameLine = styled('div')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: '#667085',
  fontSize: '12px',

  '& a': {
    color: '#7364DB',
    fontWeight: 500,
  },
});

export const FileMeta = styled('div')({
  display: 'flex',
  gap: '10px',
  minWidth: 0,
  color: '#667085',
  fontSize: '12px',

  '& span:first-of-type': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const ProgressTrack = styled('div')({
  marginTop: 8,
  height: 6,
  overflow: 'hidden',
  borderRadius: 999,
  background: '#F2F4F7',

  '& span': {
    display: 'block',
    height: '100%',
    width: '40%',
    borderRadius: 999,
    background: '#7364DB',
    animation: 'proofUpload 1.1s ease-in-out infinite',
  },

  '&[data-complete="true"] span': {
    width: '100%',
    animation: 'none',
  },

  '@keyframes proofUpload': {
    '0%': { transform: 'translateX(0%)' },
    '100%': { transform: 'translateX(250%)' },
  },
});

export const FileRemove = styled('button')({
  display: 'inline-flex',
  marginLeft: 'auto',
  padding: 4,
  border: 0,
  borderRadius: 6,
  background: 'transparent',
  color: '#667085',
  cursor: 'pointer',

  '& svg': { fontSize: 20 },

  '&:hover': { color: '#344054' },
});

export const Field = styled('div')({
  display: 'grid',
  gap: '6px',
});

export const FieldLegend = styled('p')({
  margin: 0,
  color: '#6b7280',
  fontSize: '12px',
});

export const Recorded = styled('div')({
  display: 'grid',
  justifyItems: 'start',
  gap: '2px',
});

export const RecordedLegend = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '12px',
  lineHeight: '16px',
  color: theme.palette.mode === 'dark' ? DISABLED_CONTROL_COLOR : '#6b7280',
}));

export const OptionalMark = styled('span')(({ theme }) => ({
  marginLeft: '6px',
  color: theme.palette.mode === 'dark' ? DISABLED_CONTROL_COLOR : '#6b7280',
  fontWeight: 400,
}));

export const ProofActions = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '12px',
  minWidth: 0,
});

export const ProofActionEnd = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginLeft: 'auto',
});

export const SectionActions = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingTop: 8,
});

export const FormToolbar = styled(ToolbarStyled)({
  justifyContent: 'flex-end',
  padding: '16px 0 0 !important',
});
